/**
 * Hook for handling error actions
 */
import { useCallback } from 'react';
import type { Payment, PaymentOptions } from '../../../core/resources/payments';

interface UseErrorActionParams {
    setError: (error: string | null) => void;
    setIsLoading: (loading: boolean) => void;
}

export function useErrorAction({ setError, setIsLoading }: UseErrorActionParams) {
    const handleError = useCallback(
        async (payment: Payment, actionData: any, options: PaymentOptions = {}) => {
            const errorMsg = actionData.message || 'Payment processing failed';
            const errorCode = actionData.errorCode || 'PAYMENT_FAILED';
            setError(errorMsg);
            setIsLoading(false);
            // Legacy callback (backwards compatibility)
            options.onFailure?.(errorMsg);
            // Funnel-aligned callback (recommended)
            options.onPaymentFailed?.({
                code: errorCode,
                message: errorMsg,
                payment,
            });
        },
        [setError, setIsLoading],
    );

    return { handleError };
}
